import { Dispatch } from 'react';
import { Params } from 'ahooks/lib/useAntdTable/types';
import { RawAxiosRequestHeaders } from 'axios';
import dayjs from 'dayjs';

import { apiGet } from 'api';

import { addQueryParamsToURL, getDateForPayload, getTableQueryParams } from 'utils';

import { ProductMatchesResponse } from 'codegen';

interface IInitialValues {
  matchStatuses: string[];
  collectorId?: string;
  submittedDates: dayjs.Dayjs[] | null;
  collectorNumber: string;
}

export const handleProductMatchesTableChange = (
  headers: RawAxiosRequestHeaders,
  setUrl: Dispatch<string>,
  productId?: string,
) => async (
  params: Params[0],
  {
    matchStatuses,
    collectorId,
    submittedDates,
    collectorNumber,
  }: IInitialValues,
) => {
  const { sort, ...otherParams } = getTableQueryParams(params);

  const mainParams = {
    ...(collectorId && { collectorId }),
    ...(matchStatuses && { matchStatuses }),
    ...(collectorNumber && { collectorNumber }),
    ...(submittedDates && {
      createdTo: getDateForPayload(dayjs(submittedDates[1]).endOf('day')),
      createdFrom: getDateForPayload(dayjs(submittedDates[0]).startOf('day')),
    }),
  };

  const queryParams = {
    ...otherParams,
    ...mainParams,
  };

  const url = addQueryParamsToURL(`products/details/${productId}/matches`, queryParams);

  const csvURL = addQueryParamsToURL(`products/details/${productId}/matches/export`, mainParams);

  setUrl(csvURL);

  const { data } = await apiGet<ProductMatchesResponse>({ url, headers });

  return {
    list: data.matches,
    total: data.total,
  };
};
